import React from 'react'
import { connect } from 'react-redux'
import { fetch } from '../actions'
import { Select, Spin, Divider, Icon, Button } from 'antd';
import debounce from 'lodash/debounce';
const { Option } = Select;

class UserRemoteSelect extends React.Component {

  constructor(props) {
    super(props);

    this.txtCodigo = React.createRef();    
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    this.listar = this.listar.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.state = {
      data: [],
      fetching: false,
      enterClicked: false
    };
  }

  setFocus() {
    this.txtCodigo.current.focus();
  }

  listar(value) {
    const fetchId = this.lastFetchId;
    let self = this;
    self.props.fetch().post('/cad', { modelo: this.props.modelo, txt: value })
        .then(function (response) {
            if (fetchId !== self.lastFetchId) {
            // for fetch callback order
              return;
            }

            if(self.state.enterClicked && response.data && response.data.length === 1){
              self.setState({ data: [], fetching: false, enterClicked: false});
              const d = response.data[0];
              self.props.handleChange([{key: d.id, label: d.codigo + ' - ' + d.nome}]);
            }
            else{
              self.setState({ data: response.data, fetching: false, enterClicked: false});
            }


        })
  }

  fetchUser = value => {
    this.lastFetchId += 1;    
    this.setState({ data: [], fetching: true });    
    this.listar(value);
  };

  onKeyPress = e => {
    if(e.keyCode === 13 && this.state.data.length === 0) {
      this.setState({enterClicked: true});
    }
  };

  handleChange = value => {
     
    this.setState({
      data: [],
      fetching: false,
    });

    if(!this.props.multi && value && value.length > 1)
    {
      this.props.handleChange([value[value.length - 1]]);
      return;
    } 
    
    this.props.handleChange(value);      
  };

  render() {
    const { fetching, data, value } = this.state;
   
      const self = this;
      return ( 
        <>
        <Select
          mode="multiple"
          ref={this.txtCodigo}
          autoFocus={this.props.autoFocus}
          labelInValue
          maxTagTextLength={this.props.maxTagTextLength ? this.props.maxTagTextLength : 20}
          value={this.props.dados}
          placeholder={this.props.placeholder ? this.props.placeholder :  "Digite a pesquisa"}
          notFoundContent={fetching ? <Spin size="small" /> : null}
          filterOption={false}
          onSearch={this.fetchUser}
          onChange={this.handleChange}
          onInputKeyDown={this.onKeyPress}
          disabled={this.props.disabled}
          style={{width:'100%', ...this.props.style}}         
        >
          {data.map(d => (
            <Option key={d.id}>{d.codigo + ' - ' + d.nome}</Option>
          ))}
        </Select>
       
        </>
      );
    
   
  }
}

export default connect(null, { fetch }, null, {forwardRef :true})(UserRemoteSelect);
